<template>
  <div v-if="showElement"
       class="xyj_authority"
       :name="base"
       :chinaseName="chinasename"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "AuthorityControl",
  props: {
    name: {
      type: String,
      default: function() {
        return "";
      }
    },
    chinasename: {
      // 组件的详细中文名 如：首页轮播图
      type: String,
      default: function() {
        return "";
      }
    }
  },
  data() {
    return {
      base: "", // 当前的基础名称 主要是后台要
      showElement: true // 是否显示当前元素
    };
  },
  mounted() {
    const self = this;
    if (!this.name) {
      console.error("请传入控制这部分板块的名称，接收一个name参数");
      return;
    }
    this.$bus.$emit("getComponentName", function(componentName) {
      self.base = componentName + "-" + self.name;
    });
  },
  methods: {}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/appComponents/authorityControl.vue